const BURST_APPROACHING_RATIO = 0.8;

export type BurstVerdict = "no-allowance" | "on-track" | "approaching" | "over";

type BurstBudget = {
  budgetMinutes: number;
  usedMinutes: number;
};

export const getBurstVerdict = ({ budgetMinutes, usedMinutes }: BurstBudget): BurstVerdict => {
  // A P100 contract has no allowance to measure against, and `used >= 0 * 0.8`
  // would otherwise read as approaching for an idle account.
  if (budgetMinutes <= 0) {
    return "no-allowance";
  }

  if (usedMinutes > budgetMinutes) {
    return "over";
  }

  if (usedMinutes >= budgetMinutes * BURST_APPROACHING_RATIO) {
    return "approaching";
  }

  return "on-track";
};
